// Renders the small Markdown subset used in lesson content (paragraphs,
// bullet/numbered lists, **bold**) as React elements. No raw HTML is injected.

const LIST_ITEM = /^\s*(?:[-*•]|(\d+)[.)])\s+(.*)$/;

const inline = (line, keyPrefix) =>
  line
    .replace(/^#+\s*/, "")
    .split(/(\*\*[^*]+\*\*)/g)
    .filter(Boolean)
    .map((part, i) =>
      part.startsWith("**") && part.endsWith("**") ? (
        <strong key={`${keyPrefix}-${i}`}>{part.slice(2, -2)}</strong>
      ) : (
        part
      )
    );

export const parseBlocks = (source) => {
  const blocks = [];
  let paragraph = [];
  let list = null;

  const flushParagraph = () => {
    if (paragraph.length) blocks.push({ type: "p", lines: paragraph });
    paragraph = [];
  };
  const flushList = () => {
    if (list) blocks.push(list);
    list = null;
  };

  source.split(/\r?\n/).forEach((line) => {
    const item = line.match(LIST_ITEM);
    if (!line.trim()) {
      flushParagraph();
      flushList();
    } else if (item) {
      flushParagraph();
      const type = item[1] ? "ol" : "ul";
      if (!list || list.type !== type) {
        flushList();
        list = { type, items: [] };
      }
      list.items.push(item[2]);
    } else {
      flushList();
      paragraph.push(line.trim());
    }
  });
  flushParagraph();
  flushList();
  return blocks;
};

const Markdown = ({ children, className }) => {
  if (typeof children !== "string" || !children.trim()) return null;
  return (
    <div className={className}>
      {parseBlocks(children).map((block, i) => {
        if (block.type === "p") {
          return (
            <p key={i}>
              {block.lines.map((line, j) => (
                <span key={j}>
                  {j > 0 && <br />}
                  {inline(line, `${i}-${j}`)}
                </span>
              ))}
            </p>
          );
        }
        const List = block.type;
        return (
          <List key={i}>
            {block.items.map((item, j) => (
              <li key={j}>{inline(item, `${i}-${j}`)}</li>
            ))}
          </List>
        );
      })}
    </div>
  );
};

export default Markdown;
